import React, { useContext, useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsList";
import TabPanel from "../TabPanel";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { Button, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  tabsHeader: {
    flex: "none",
    backgroundColor: theme.palette.background.paper,
  },
  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: 8,
  },
  tab: {
    minWidth: 120,
    width: 120,
    fontSize: "0.9125rem",
    "& .MuiTab-wrapper": {
      fontSize: "0.9125rem",
    },
    "& svg": {
      fontSize: "1.39286rem",
    },
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.background.paper,
    padding: theme.spacing(1),
  },
  serachInputWrapper: {
    flex: 1,
    background: theme.palette.background.default,
    display: "flex",
    borderRadius: 40,
    padding: 4,
    marginRight: theme.spacing(1),
  },
  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },
  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
  },
  badge: {
    right: "-10px",
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },
}));

const TicketsManager = () => {
  const classes = useStyles();
  const [searchParam, setSearchParam] = useState("");
  const [inputText, setInputText] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  const { whatsApps } = useContext(WhatsAppsContext);
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [hideGroups, setHideGroups] = useState(false);

  console.log("TicketsManager: user profile", user.profile);
  console.log("TicketsManager: user.whatsapps", user.whatsapps);
  console.log("TicketsManager: whatsApps from context", whatsApps);

  useEffect(() => {
    if (user.profile && user.profile.toUpperCase() === "ADMIN") {
      setShowAllTickets(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await api.get("/settings");
        const hideGroupTabSetting = data.find(s => s.key === "hideGroupTab");
        if (hideGroupTabSetting?.value === "enabled") {
          setHideGroups(true);
        }
      } catch (err) {
        console.error("Error fetching settings", err);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
  }, [tab]);

  const searchTimeout = useRef(null);

  const handleSearch = (e) => {
    const searchedTerm = e.target.value;
    setInputText(searchedTerm);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    if (searchedTerm === "") {
      setSearchParam("");
      setTab("open");
      return;
    }

    searchTimeout.current = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 1000);
  };

  const handleCloseAllTickets = async () => {
    try {
      await api.post("/tickets/close-all", {
        status: tabOpen,
        queueIds: selectedQueueIds
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(e) => setNewTicketModalOpen(false)}
      />

      {/* GXON Header & Tabs */}
      <div className="d-flex flex-column border-bottom">
        <div className="px-3 pt-3">
          <ul className="nav nav-tabs nav-tabs-custom nav-success border-bottom-0" role="tablist">
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "open" && tabOpen === "pending" ? "active" : ""}`}
                href="javascript:void(0);"
                onClick={() => { setTab("open"); setTabOpen("pending"); }}
              >
                Aguardando
                {pendingCount > 0 && <span className="badge bg-danger ms-2">{pendingCount}</span>}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "open" && tabOpen === "open" ? "active" : ""}`}
                href="javascript:void(0);"
                onClick={() => { setTab("open"); setTabOpen("open"); }}
              >
                Conversando
                {openCount > 0 && <span className="badge bg-primary ms-2">{openCount}</span>}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "closed" ? "active" : ""}`}
                href="javascript:void(0);"
                onClick={() => setTab("closed")}
              >
                Resolvidos
              </a>
            </li>
            {
              !hideGroups && (
                <li className="nav-item">
                  <a
                    className={`nav-link ${tab === "groups" ? "active" : ""}`}
                    href="javascript:void(0);"
                    onClick={() => setTab("groups")}
                  >
                    Grupos
                  </a>
                </li>
              )
            }
          </ul >
        </div >

        <div className="d-flex p-3 align-items-center justify-content-between bg-light bg-opacity-50">
          <div className="d-flex align-items-center shadow-sm rounded-2 position-relative w-100 bg-white">
            <button type="button" className="btn btn-sm border-0 position-absolute start-0 ms-3 p-0">
              <i className="fi fi-rr-search"></i>
            </button>
            <input
              ref={searchInputRef}
              type="text"
              className="form-control ps-5 border-0 shadow-none"
              placeholder="Buscar contatos ou mensagens..."
              value={inputText}
              onChange={(e) => {
                handleSearch(e);
                if (tab !== "search") setTab("search");
              }}
            />
          </div>
          <Button
            variant="contained"
            color="primary"
            className="ms-2 btn-icon"
            onClick={() => setNewTicketModalOpen(true)}
            style={{ minWidth: '40.6px', height: '40.6px', borderRadius: '8px', padding: 0 }}
          >
            <i className="fi fi-rr-plus"></i>
          </Button>
        </div>

        <div className="px-3 pb-2 d-flex align-items-center justify-content-between bg-light bg-opacity-50">
          <TicketsQueueSelect
            style={{ flex: 1 }}
            selectedQueueIds={selectedQueueIds}
            userQueues={user?.queues}
            onChange={(values) => setSelectedQueueIds(values)}
          />

          <FormControl variant="outlined" style={{ flex: 1, marginLeft: 10, minWidth: 200 }}>
            <InputLabel id="whatsapp-select-label">Conexão</InputLabel>
            <Select
              labelId="whatsapp-select-label"
              id="whatsapp-select"
              value={selectedWhatsapp}
              onChange={(e) => setSelectedWhatsapp(e.target.value)}
              label="Conexão"
              margin="dense"
            >
              <MenuItem value="">
                <em>Todas as conexões</em>
              </MenuItem>
              {whatsApps
                .filter((w) => {
                  const profile = user.profile?.toLowerCase();
                  if (profile === "admin") return true;
                  return user.whatsapps?.some((uw) => (uw.id || uw) == w.id) || user.whatsappId == w.id;
                })
                .map((whatsapp) => (
                  <MenuItem key={whatsapp.id} value={whatsapp.id}>
                    {whatsapp.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {tab === "open" && tabOpen === "pending" && (
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCloseAllTickets}
              style={{ marginLeft: 10 }}
            >
              Fechar Todos
            </Button>
          )}

          <Can
            role={user.profile}
            perform="tickets-manager:showall"
            yes={() => (
              <div className="ms-2">
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={showAllTickets}
                      onChange={() => setShowAllTickets((prevState) => !prevState)}
                      color="primary"
                    // ...
                    />
                  }
                  label="Ver Todos"
                  labelPlacement="start"
                />
              </div>
            )}
          />
        </div>
      </div >

      {/* Content Panels */}
      < div className={classes.ticketsWrapper} >
        {tab === "open" && (
          <div className={classes.ticketsWrapper}>
            <TicketsList
              status="open"
              showAll={showAllTickets}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setOpenCount(val)}
              style={applyPanelStyle("open")}
              whatsappId={selectedWhatsapp}
            />
            <TicketsList
              status="pending"
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setPendingCount(val)}
              style={applyPanelStyle("pending")}
              whatsappId={selectedWhatsapp}
            />
          </div>
        )}
        {
          tab === "closed" && (
            <TicketsList
              status="closed"
              showAll={true}
              selectedQueueIds={selectedQueueIds}
              whatsappId={selectedWhatsapp}
            />
          )
        }
        {
          tab === "groups" && (
            <TicketsList
              status="groups"
              showAll={true}
              selectedQueueIds={selectedQueueIds}
              whatsappId={selectedWhatsapp}
            />
          )
        }
        {
          tab === "search" && (
            <TicketsList
              searchParam={searchParam}
              showAll={true}
              selectedQueueIds={selectedQueueIds}
              whatsappId={selectedWhatsapp}
            />
          )
        }
      </div >
    </Paper >
  );
};

export default TicketsManager;
